import React, { useState, useEffect, useRef } from 'react';
import VideoStream from './VideoStream';
import UserForm from './UserForm';
import './firstPartyData.css';
import Loader from './Loader';
import { NewLoader } from './NewLoader';
import CloseIcon from "@mui/icons-material/Close";
import { useLocation } from 'react-router-dom';

const FirstPartyData = ({ batchId, brandId, customerKey, onClose, setShowSuccessNotification }) => {
  const [templateId, setTemplateId] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [templateStyles, setTemplateStyles] = useState({});

  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const isStandaloneForm = location.pathname === "/ar/form";

  // const [showScrollIndicator, setShowScrollIndicator] = useState(true);
  // const containerRef = useRef(null);

  const [isOptional, setIsOptional] = useState(true);

  const [backgroundUrl, setBackgroundUrl] = useState("");

  let BASE_URL = process.env.REACT_APP_CONFIG_API_URL?.trim() || "https://devapi.fiduciaai.in";





  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const response = await fetch(
          BASE_URL + "/api/getFirstPartyData",
          // "https://cloudbee.fiducia-ai.com/cebackendapi/getFirstPartyData",   // hardcoded for temporary usage
          // "https://devapi.fiduciaai.in/api/getFirstPartyData",
          // "https://devapi.fiduciaai.in/api/getTemplateInfo",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
            },
            body: JSON.stringify({
              customerkey: customerKey,
              brandid: brandId,
              batchid: batchId,
            }),
          }
        );

        if (!response.ok) throw new Error("Failed to fetch first party data");

        const data = await response.json();
        console.debug("API Response: ", data);

        const templateId = data?.model?.templateid;

        setIsOptional(data?.model?.field3 === "mandatory" ? false : true);

        if (!templateId) throw new Error("Template ID not found");

        setTemplateId(templateId);

        const templateInfo = data?.model?.templateInfo;
        if (templateInfo) {
          if (templateInfo.templateFields && Array.isArray(templateInfo.templateFields)) {
            console.log("Setting template fields: ", templateInfo.templateFields);
            setTemplates(templateInfo.templateFields);
          }

          if (templateInfo.templateStyles?.styles) {
            try {
              console.log("Template Styles: ", templateInfo);
              const styles = JSON.parse(templateInfo.templateStyles.styles);

              console.log("Setting template styles: ", styles);
              setTemplateStyles(styles);
            }
            catch (error) {
              console.error("Error parsing template styles:", error);
              setTemplateStyles({});
            }
          }
          else {
            setTemplateStyles({
              templateMessage: "Please fill out the form below",
            });
          }
        }
      }
      catch (error) {
        console.error("Error fetching first party data: ", error);
      }
      finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [batchId, brandId, customerKey]);


  // useEffect(() => {
  //   const container = containerRef.current;

  //   if (!container) return;

  //   const handleScroll = () => {
  //     setShowScrollIndicator(false);
  //   };

  //   const handleTouchStart = () =>{
  //     setShowScrollIndicator(true);
  //   };

  //   container.addEventListener("scroll", handleScroll);
  //   container.addEventListener("touchstart", handleTouchStart);

  //   return () => {
  //     container.removeEventListener("scroll", handleScroll);
  //     container.removeEventListener("touchstart", handleTouchStart);
  //   }
  // }, []);


  const handleFormClose = () => {
    onClose();
  }


  return (
    <>
      <div className='first-party-data-overlay'
      >
        <div className='first-party-data-container'>



          <header className='fpd-header'>
            {isOptional && !isStandaloneForm ? (
              <button className='close-button' onClick={  handleFormClose}>
                <CloseIcon style={{ color: " #ff6b6b", fontSize: "1.8rem", }} />
              </button>
            ) : <></>}
            <h2 className='fpd-title'>
              {templateStyles?.templateMessage || "Please fill out the form below"}
            </h2>
          </header>

          {loading ? (
            <div className='fpd-loader'>
              <NewLoader />
            </div>
          ) : (
            <div className='fpd-content'>
              <VideoStream
                templates={templates}
                templateStyles={templateStyles}
              />

              <div className='form-section'>
                <UserForm
                  templates={templates}
                  customerKey={customerKey}
                  brandId={brandId}
                  batchId={batchId}
                  onClose={onClose}
                  setShowSuccessNotification={setShowSuccessNotification}
                />

              </div>
            </div>
          )}

          {/* scrolling cue  */}
          <div className='scroll-indicator'>
            <div className='scroll-wheel'></div>
          </div>


        </div>
      </div>

    </>
  )
}

export default FirstPartyData;